import { colors } from '@aloft/toolkit-sui';
import { Font, Text as ReactPDFText, StyleSheet } from '@react-pdf/renderer';

Font.register({ family: 'Lato-Light', src: '/Lato-Light.ttf' });
Font.register({ family: 'Lato-Bold', src: '/Lato-Bold.ttf' });
Font.register({ family: 'Lato-Regular', src: '/Lato-Regular.ttf' });
Font.register({ family: 'Lato-Italic', src: '/Lato-Italic.ttf' });

const styles = StyleSheet.create({
  h1: {
    fontSize: 19,
    lineHeight: 1.8,
    fontFamily: 'Lato-Bold',
    color: colors.textPrimary,
  },
  h2: {
    fontSize: 16,
    fontFamily: 'Lato-Bold',
    color: colors.textPrimary,
    marginBottom: '8px',
  },
  h3: {
    fontSize: 14,
    fontFamily: 'Lato-Bold',
    color: colors.textPrimary,
    marginBottom: '3px',
  },
  h4: {
    fontSize: 11,
    lineHeight: 1.6,
    fontFamily: 'Lato-Bold',
    color: colors.textPrimary,
  },
  h5: {
    fontSize: 10,
    fontFamily: 'Lato-Bold',
    color: colors.textPrimary,
  },
  subtitle3: {
    fontSize: 8,
    fontFamily: 'Lato-Regular',
    color: colors.textSecondary,
  },
  body: {
    fontSize: 10,
    fontFamily: 'Lato-Light',
    fontWeight: 400,
    color: colors.textPrimary,
  },
  th: {
    fontSize: 9,
    fontFamily: 'Lato-Regular',
    color: colors.textPrimary,
  },
  td: {
    fontSize: 8,
    fontFamily: 'Lato-Regular',
    color: colors.textPrimary,
  },
  h6: {},
  subtitle1: {
    color: colors.textSecondary,
    fontSize: 12,
    fontWeight: 'semibold',
    fontFamily: 'Lato-Regular',
    textTransform: 'uppercase',
  },
  subtitle2: {},
  body1: {
    fontSize: 10,
    fontFamily: 'Lato-Regular',
    fontWeight: 'normal',
    color: colors.textPrimary,
    lineHeight: 1.6,
  },
  body2: {
    fontSize: 8,
    fontFamily: 'Lato-Light',
    color: colors.textSecondary,
    marginTop: '2px',
  },
  link: {},
  placeholder: {},
  buttonSmall: {},
  buttonRegular: {},
  chip: {},
  tableColumnTitle: {},
  tableH1: {},
  tableH2: {},
  tableH3: {},
  tableTag: {},
  displayLarge: {},
  displayMedium: {},
  displaySmall: {},
  tableHelperText: {
    fontSize: 7,
    fontFamily: 'Lato-Light',
    color: colors.textSecondary,
    marginTop: '-12pt',
  },
  label: {},
  underlined: {
    textDecoration: 'underline',
    textDecorationColor: colors.alertError,
    textDecorationStyle: 'dotted',
  },
});

type Props = {
  children: string;
  variant?: keyof typeof styles;
  marginTop?: string;
  underlined?: boolean;
  textAlign?: 'left' | 'center' | 'right';
  fontWeight?: 'bold' | 'light' | 'regular';
  lineHeight?: number;
  padding?: string;
  flex?: number;
};

export const Text = ({
  variant = 'h2',
  marginTop,
  underlined,
  children,
  textAlign,
  fontWeight,
  lineHeight,
  padding,
  flex,
}: Props) => (
  <ReactPDFText
    style={[
      styles[variant],
      { marginTop },
      underlined ? styles.underlined : {},
      textAlign ? { textAlign } : {},
      fontWeight === 'bold' ? { fontFamily: 'Lato-Bold' } : {},
      fontWeight === 'light' ? { fontFamily: 'Lato-Light' } : {},
      lineHeight ? { lineHeight } : {},
      padding ? { padding } : {},
      flex ? { flex } : {},
    ]}
  >
    {children}
  </ReactPDFText>
);
